import { CreateAccessTokenMetadataDto } from 'shared/interfaces/livekit/CreateAccessToken';
import { axiosBaseInstance } from 'shared/utils/axios-instances';

const liveKitBaseEndpoint = '/livekit';

export const LiveKitService = {
  createAccessTokenForNewRoom: async (createAccessTokenMetadataDto: CreateAccessTokenMetadataDto) => {
    const response = await axiosBaseInstance({
      method: 'post',
      url: `${liveKitBaseEndpoint}/access-token`,
      data: createAccessTokenMetadataDto
    });

    return response.data as string;
  }
};
